var poll_default = {
  "fontElementMap": "dgNfP",
  "container": "_837T8",
  "fullscreen": "BI6sR",
  "background_overlay": "-HPrt",
  "with_image": "IviEO",
  "options": "uDk-a",
  "webview": "fQYCi",
  "grid": "XKO6f",
  "option": "FVH0q",
  "cta_button": "rdaAm",
  "add_option": "_42SAa",
  "see_more": "-miY8",
  "list": "Sf-WR",
  "column": "_1MrVa",
  "additional_note": "_9ml3b",
  "spinner": "OzDxA",
  "spin": "BALpa",
  "shown": "DGX93",
  "error": "r3ptE"
};
export {
  poll_default as default
};
//# sourceMappingURL=poll-scss.js.map
